import { render, staticRenderFns } from "./dashMetasExecutivos.vue?vue&type=template&id=3835ac46&scoped=true"
import script from "./dashMetasExecutivos.vue?vue&type=script&lang=js"
export * from "./dashMetasExecutivos.vue?vue&type=script&lang=js"
import style0 from "./dashMetasExecutivos.vue?vue&type=style&index=0&id=3835ac46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835ac46",
  null
  
)

export default component.exports